const importEngine = {
  title: "מנוע ייבוא",
  description: "ייבוא קבצי CSV/Excel למערכת הישויות",
  uploadFile: "העלאת קובץ",
  dragDrop: "גרור קובץ לכאן",
  orClickBrowse: "או לחץ לבחירה",
  supportedFormats: "פורמטים נתמכים: CSV, XLSX, XLS",
  maxFileSize: "מקסימום 5MB",
  maxRows: "מקסימום 5,000 שורות",
  selectEntityType: "בחר סוג ישות",
  columnMapping: "מיפוי עמודות",
  autoDetect: "זיהוי אוטומטי",
  autoDetectAll: "זיהוי אוטומטי לכולם",
  sourceColumn: "עמודת מקור",
  targetField: "שדה יעד",
  detectedType: "סוג מזוהה",
  confidence: "רמת ביטחון",
  skip: "דלג",
  preview: "תצוגה מקדימה",
  previewDescription: "מציג את 10 השורות הראשונות",
  validRows: "שורות תקינות",
  invalidRows: "שורות שגויות",
  skippedColumns: "עמודות שדולגו",
  errorRate: "אחוז שגיאות",
  errorRateWarning: "אחוז שגיאות גבוה מדי (מקסימום 10%)",
  importing: "מייבא",
  importComplete: "הייבוא הושלם",
  importFailed: "הייבוא נכשל",
  importProgress: "התקדמות",
  rowsImported: "שורות יובאו",
  rowsFailed: "שורות נכשלו",
  errors: "שגיאות",
  back: "חזרה",
  next: "הבא",
  startImport: "התחל ייבוא",
  importHistory: "היסטוריית ייבוא",
  fileName: "שם קובץ",
  entityType: "סוג ישות",
  date: "תאריך",
  status: "סטטוס",
  statusPending: "ממתין",
  statusProcessing: "מעבד",
  statusCompleted: "הושלם",
  statusFailed: "נכשל",
  noImports: "אין ייבואים עדיין",
  viewErrors: "צפה בשגיאות",
  downloadErrors: "הורד שגיאות",
} as const;
export default importEngine;
